import React from 'react';
import { profileData } from '../data/mock';
import { Linkedin, Github } from 'lucide-react';

const XIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

/* Mirrors the running footer on every page of the print portfolio */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-cream border-t border-rule py-8">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="eyebrow">
            {profileData.name} · Portfolio · {currentYear}
          </p>

          <div className="flex items-center gap-5">
            <a
              href={profileData.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="LinkedIn"
            >
              <Linkedin size={17} />
            </a>
            <a
              href={profileData.social.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="X (Twitter)"
            >
              <XIcon size={15} />
            </a>
            <a
              href={profileData.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="GitHub"
            >
              <Github size={17} />
            </a>
            <a
              href={`mailto:${profileData.email}`}
              className="eyebrow hover:text-ink transition-colors normal-case"
            >
              {profileData.email}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
